// ********************************************************
// Translations
// Definitions of some commen translations.
// The text are generel resuable via Vue mixin.
// ********************************************************

export default {
  computed: {
    // Common Translations
    ct () {
      return {
        TitleText: this.id === '00000000-0000-0000-0000-000000000000' || this.id === undefined
          ? this.$t('Create') + ' ' + this.$t(this.dataType) : this.$t('Edit') + ' ' + this.$t(this.dataType),
        SaveBtnText: this.id === '00000000-0000-0000-0000-000000000000'
          ? this.$t('Create') : this.$t('Save'),
        Active: this.$t('Active'),
        Show_inactive: this.$t('Show inactive'),
        Id: this.$t('No.'),
        No: this.$t('No.'),
        Name: this.$t('Name'),
        Full_name: this.$t('Full name'),
        Corporation: this.$t('Corporation'),
        Email: this.$t('Email'),
        Comment: this.$t('Comment'),
        Description: this.$t('Description'),
        Claims: this.$t('Claims'),
        Facilities: this.$t('Facilities'),
        UserGroups: this.$t('User Groups'),
        NoDataAvailable: this.$t('No data available'),
        AllowMSAccountLogin: this.$t('allowMSAccountLogin')
      }
    }
  }
}
